import React from 'react';
import TravelerPreferences from 'components/BusinessLogic/RegularTravelers/TravelerPreferences/Loadable';
import { connect } from 'react-redux';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import PropTypes from 'prop-types';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import Skeleton from 'components/UI/Skeleton';
import Container from 'components/UI/Layout/Container';

function AgentPreferencesWidget({ authMember })
{
    return (
        <CollapsibleCard
            title="Agent Preferences"
            storeId="agent_preferences_profile"
        >
            <Container className="tw-w-full tw-ml-3">
                <TravelerPreferences
                    fallback={<Skeleton type="table" className="tw-bg-white tw-p-10" />}
                    travelerId={authMember.id}
                    showTitle={false}
                    showAdd
                />
            </Container>
        </CollapsibleCard>
    );
}

AgentPreferencesWidget.propTypes = {
    authMember: PropTypes.object,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
    });
};

export default connect(mapStateToProps)(AgentPreferencesWidget);
